import { Card, Divider, IconButton, Link, Typography, useTheme } from "@mui/material";
import { SegurancaBarragem } from "../../services/api/segBarragem";
import { Delete, Edit } from "@mui/icons-material";
import { EventoBarragem } from "../../services/api/company";
import { useApi } from "../../services";
import { useEffect, useState } from "react";
import { BarragemData, useUserContext } from "../../context";

export const CardInspecao: React.FC<{
  onEdit?: (evento: EventoBarragem) => void;
  onRemove?: (segurancaBarragem: SegurancaBarragem) => void;
  inspecao: SegurancaBarragem;
  inspecaoAnterior?: SegurancaBarragem;
}> = ({ inspecao, inspecaoAnterior, onRemove, onEdit }) => {
  const { palette } = useTheme();
  const api = useApi();
  const user = useUserContext();

  const [barragem, setBarragem] = useState<BarragemData>();

  // Obtendo dados da barragem do simulado
  useEffect(() => {
    api.barragem.getBarragemById(inspecao.idBarragem).then(value => {
      if ('error' in value) return;
      setBarragem(value);
    });
  }, [inspecao]);

  const handleClick = () => {
    if (inspecao.file) window.open(inspecao.file, '_blank');
  };

  if (!user || "error" in user) return <Typography fontWeight={700} fontSize={18}>Sem Usuário</Typography>;

  return <Card sx={{
    padding: 2,
    gap: "5px",
    width: "18em",
    display: "flex",
    flexDirection: "column",
    bgcolor: palette.calendario.inspecaoCardColor,
  }}>
    <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
      <Typography fontWeight={700} fontSize={18}>{`Inspeção Técnica${barragem?.nome ? ` em ${barragem.nome}` : ""}`}</Typography>
      <div style={{ flex: 1 }} />
      {user.admin && onEdit && <IconButton onClick={() => onEdit({ tipo: "segurancaBarragem", evento: inspecao })} size="small">
        <Edit fontSize="small" />
      </IconButton>
      }
      {user.admin && onRemove &&
        <IconButton onClick={() => onRemove(inspecao)} size="small">
          <Delete fontSize="small" />
        </IconButton>
      }
    </div>
    <Divider />
    <Item title="Tipo" value={inspecao.tipo} />
    {inspecao.outro && <Item title="Outro" value={inspecao.outro} />}
    <Item title="Horário de Inspeção" value={inspecao.data.getHours().toSignificantDigits('horaData') + ":" + inspecao.data.getHours().toSignificantDigits('minutoData')} />
    <Item title="Responsável" value={inspecao.responsavel} />
    {inspecaoAnterior && <Item title="Data da última inspeção" value={inspecaoAnterior.data.getDate().toSignificantDigits('dia') + "/" + (inspecaoAnterior.data.getMonth() + 1).toSignificantDigits('mes') + "/" + inspecaoAnterior.data.getFullYear().toString()} />}
    {inspecaoAnterior && <Item title="Tipo da última inspeção" value={inspecaoAnterior.tipo} />}
    {inspecaoAnterior && inspecaoAnterior.outro && <Item title="Outro" value={inspecaoAnterior.outro} />}

    {/* Arquivo */}
    <div style={{ display: "flex", flexDirection: "row" }}>
      <Typography fontWeight={700} fontSize={14}>
        •&nbsp;Arquivo:&nbsp;
      </Typography>
      {
        inspecao.file ?
          <Link onClick={handleClick}>acesse aqui</Link> :
          <Typography fontSize={14}>nenhum arquivo</Typography>
      }
    </div>

    {/* Observações por último */}
    {inspecao.obs && <Item title="Observações" value={inspecao.obs} />}
  </Card>;

};

const Item = ({ title, value }: { title: string; value: string; }) => {
  return <div style={{ display: "flex", flexDirection: "row" }}>
    <Typography fontWeight={700} fontSize={14}>
      •&nbsp;{title}:&nbsp;
    </Typography>
    <Typography fontSize={14}>
      {value}
    </Typography>
  </div>;
};

